import {connect} from '../../app/connect';
import LinkedDocumentInlineEdit from './LinkedDocumentInlineEdit';
import {getCurrentViewType, getDocumentCollection} from '../../app/selectors';

const mapStateToProps = state => ({
  viewType: getCurrentViewType(state),
  documentCollection: getDocumentCollection(state)
});

export default connect(mapStateToProps)(LinkedDocumentInlineEdit);
